<template>
    <section class="min-h-[85vh] bg-white align-middle flex flex-col justify-center bg-gray">
      <div class="max-w-screen mx-auto px-4 flex flex-col items-center py-12 my-6 justify-center text-center">
        <img src="@/assets/img/favicon.png">
        <p class="mt-8 text-[#f28c1f] text-[24px] leading-tight font-semibold max-w-4xl">{{ tr("_ExpiredText") }}</p>
      </div>
      
    </section>
  </template>
  <script>
  export default {
    name: "ExpiredPage",
    computed: {
    },
    data() {
      return {};
    },
    components: {},
    methods: {
      tr(key) {
        return this.$root.tr(key);
      },
    },
  };
  </script>
  